import React, { useEffect, useRef, useState } from "react";
import Layouts from "../../Layouts";
import SlotService from "../../../Services/SlotService";
import dayjs from "dayjs";
import {
  Checkbox,
  DatePicker,
  Form,
  Input,
  message,
  Select,
  Switch,
  TimePicker,
} from "antd";
import CommonFunctions from "../../Shared/CommonFunctions";
import DoctorService from "../../../Services/DoctorService";
import ConsultationService from "../../../Services/ConsultationService";
import { LiaToggleOnSolid } from "react-icons/lia"; // <LiaToggleOnSolid />
import { LiaToggleOffSolid } from "react-icons/lia"; // <LiaToggleOffSolid />
import PatientService from "../../../Services/PatientService";
import PatientQueue from "../VCPage/PatientQueue";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import Draggable from "react-draggable";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import { IoIosCloseCircle } from "react-icons/io";
import moment from "moment";
const consultationTypes = ["inPerson", "video", "home"];

function Slot() {
  const formRef = useRef();
  const [accounts, setAccounts] = useState([]);
  const [clinics, setClinics] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedAccId, setSelectedAccId] = useState(null);
  const [selectedClinicId, setSelectedClinicId] = useState(null);
  const [appointmentTypes, setAppointmentTypes] = useState(consultationTypes);
  const [availableFromDate, setAvailableFromDate] = useState("");
  const [availableToDate, setAvailableToDate] = useState("");
  const [availableFromTime, setAvailableFromTime] = useState("");
  const [availableToTime, setAvailableToTime] = useState("");
  const [consDuration, setConsDuration] = useState("");
  const [savedUserSlots, setSavedUserSlots] = useState([]);
  const [slotLoader, setSlotLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [days, setDays] = useState([]);
  const [fromDate, setFromDate] = useState();
  const [fromTime, setFromTime] = useState(null);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const durationArr = [10, 15, 20, 30, 40, 50, 60];

  useEffect(() => {
    getUserSavedSlots();
  }, []);

  const getUserSavedSlots = async () => {
    const payload = {
      userId: loggedUser.user.userId,
      clinic_Id: loggedUser.user.clinic_Id,
      status: 1,
    };
    try {
      const response = await SlotService.GetSlotDetails(payload);
      const activeSlots = response.data.filter(
        (slot) => !dayjs(slot.toDate, "MM/DD/YYYY").isBefore(dayjs()),
      );
      setSavedUserSlots(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleInactiveSlot = async (data) => {
    setSlotLoader(true);
    try {
      await SlotService.InActiveSlots(data.id);
      setSlotLoader(false);
      getUserSavedSlots();
    } catch (e) {
      console.error(e);
      setSlotLoader(false);
    }
  };

  const handleConsType = (checkedValues) => {
    setAppointmentTypes(checkedValues);
  };

  const handleDays = (checkedDays) => {
    const isSelectedAll = checkedDays?.includes("all");
    const allDays = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    if (!days.includes("all") && checkedDays.includes("all")) {
      setDays([...allDays, "all"]);
    } else if (
      days.includes("all") &&
      isSelectedAll &&
      checkedDays.length - 1 < 7
    ) {
      const filtered = checkedDays.filter((item) => item !== "all");
      setDays(filtered);
    } else if (!days.includes("all") && checkedDays.length < 7) {
      setDays(checkedDays);
    }
    // If select all checkbox is in unchecked mode...
    else if (!isSelectedAll) {
      // If select all checkbox only unchecked
      if (checkedDays.length === 7 && days.length > 7) {
        setDays([]);
      }
      // If all days checkbox is checked. Then check select all checkbox automatically.
      else {
        setDays([...allDays, "all"]);
      }
    }
    // This block of code not triggered yet.
    else if (!checkedDays?.includes("all")) {
      setDays([]);
    }
  };

  const calculateDiscount = (fee, discount) => {
    // Ensure fee and discount are valid numbers
    if (typeof fee !== "number" || fee < 0) {
      console.error("Invalid fee value:", fee);
      return { discountAmount: 0, payableAmount: fee || 0 };
    }
    if (typeof discount !== "number" || discount < 0 || discount > 100) {
      console.error("Invalid discount value:", discount);
      return { discountAmount: 0, payableAmount: fee };
    }

    // Calculate discount and payable amount
    let discountAmount = fee * (Math.floor(discount) / 100);
    let payableAmount = fee - discountAmount;

    return { discountAmount, payableAmount };
  };

  const handleSlotSave = async () => {
    const {
      inpersonfee,
      videofee,
      inpersondiscount,
      videodiscount,
      homeVisitfee,
      homeVisitDiscount,
    } = formRef.current.getFieldValue();

    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;
    setIsLoading(true);

    const validateDiscAndCalc = (fee, discountPerc) => {
      if (!fee) return { discAmt: 0, payAmt: 0 };
      if (fee && !discountPerc) return { discAmt: 0, payAmt: fee };
      const discAmt = (fee * (discountPerc / 100)).toFixed(2);
      const payAmt = (fee - discAmt).toFixed(2);
      return { discAmt, payAmt };
    };

    const { discAmt: inPersonDisAmt, payAmt: inPersonPayAmt } =
      validateDiscAndCalc(inpersonfee, inpersondiscount);
    const { discAmt: videoDisAmt, payAmt: videoPayAmt } = validateDiscAndCalc(
      videofee,
      videodiscount,
    );
    const { discAmt: homeDisAmt, payAmt: homePayAmt } = validateDiscAndCalc(
      homeVisitfee,
      homeVisitDiscount,
    );

    const missingFields = [];

    // if (inpersonfee == "") missingFields.push("In-Person Fee");
    // if (videofee == "") missingFields.push("Video Fee");
    // if (homeVisitfee == "") missingFields.push("Home Visit Fee");
    if (!availableFromDate) missingFields.push("From Date");
    if (!availableToDate) missingFields.push("To Date");
    if (!availableFromTime) missingFields.push("Start Time");
    if (!availableToTime) missingFields.push("End Time");
    if (!consDuration) missingFields.push("Duration");
    if (missingFields.length > 0) {
      message.error(`Please fill: ${missingFields.join(", ")}`);
      setIsLoading(false);
      return;
    }

    if (days && days.length === 0) {
      message.error("Please select day(s)");
      setIsLoading(false);
      return;
    }

    const ConvertTime = (time) => {
      const timePart = time.format("HH:mm");
      return `${timePart}`;
    };

    const payload = {
      accountName: loggedUser?.user?.accountName,
      account_Id: loggedUser?.user?.account_Id,
      clinicName: loggedUser.user?.clinicName,
      clinic_Id: loggedUser.user.clinic_Id,
      consultationDuration: consDuration,
      createdBy: loggedUser?.user?.userId,
      createdDate: constructedTime,
      friday: days.includes("friday") ? "Y" : "N",
      fromDate: availableFromDate,
      fromTime: ConvertTime(dayjs(availableFromTime)),
      inPerson: appointmentTypes.includes("inPerson") ? "Y" : "N",
      inpersonFee: inpersonfee ? inpersonfee : loggedUser.user.inpersonFee,
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: constructedTime,
      monday: days.includes("monday") ? "Y" : "N",
      publicHolidays: "",
      saturday: days.includes("saturday") ? "Y" : "N",
      status: 1,
      sunday: days.includes("sunday") ? "Y" : "N",
      thursday: days.includes("thursday") ? "Y" : "N",
      toDate: availableToDate,
      toTime: ConvertTime(dayjs(availableToTime)),
      tuesday: days.includes("tuesday") ? "Y" : "N",
      userId: loggedUser.user.userId,
      userName: loggedUser.user.firstName,
      video: appointmentTypes.includes("video") ? "Y" : "N",
      videoFee: videofee ? videofee : loggedUser.user.videoFee,
      homeVisitFee: homeVisitfee ? homeVisitfee : loggedUser.user.homeVisitFee,
      wednesday: days.includes("wednesday") ? "Y" : "N",
      inPersonDiscountAmount: inPersonDisAmt,
      inPersonDiscountPercentage: inpersondiscount ? inpersondiscount : 0,
      inPersonPayableAmount: inPersonPayAmt,
      videoConsultDiscountAmount: videoDisAmt,
      videoConsultDiscountPercentage: videodiscount ? videodiscount : 0,
      videoConsultPayableAmount: videoPayAmt,
      homeVisitDiscountAmount: homeDisAmt,
      homeVisitDiscountPercentage: homeVisitDiscount ? homeVisitDiscount : 0,
      homeVisitPayableAmount: homePayAmt,
      homeVisit: appointmentTypes.includes("home") ? "Y" : "N",
    };

    try {
      await SlotService.SaveSlot(payload);
      getUserSavedSlots();
      message.success("Slot template created successfully.");
      setAvailableFromDate("");
      setAvailableToDate("");
      setAvailableFromTime("");
      setAvailableToTime("");
      setConsDuration("");
      setDays("");
      setIsLoading(false);
      formRef.current.resetFields();
    } catch (e) {
      console.error(e);
      e && message.error(e.response.data.message);
      setIsLoading(false);
    }
  };

  const handleFromDate = (date, dateString) => {
    setAvailableFromDate(dateString);
    setFromDate(date);
    if (date && date.isSame(moment(), "day")) {
      // Reset time to current time if today is selected
      setFromTime(moment());
    } else {
      setFromTime(null); // Reset time if not today
    }
  };

  const disabledTime = () => {
    if (fromDate && fromDate.isSame(moment(), "day")) {
      const currentHour = moment().hour();
      const currentMinute = moment().minute();
      return {
        disabledHours: () =>
          [...Array(24).keys()].filter((h) => h < currentHour),
        disabledMinutes: (selectedHour) =>
          selectedHour === currentHour
            ? [...Array(60).keys()].filter((m) => m < currentMinute)
            : [],
      };
    }
    return {}; // No restrictions for other days
  };

  const handleToDate = (date, dateString) => {
    setAvailableToDate(dateString);
  };

  const handleFromTime = (time, timeString) => {
    setAvailableFromTime(time);
  };

  const handleToTime = (time, timeString) => {
    setAvailableToTime(time);
  };

  const handleConsDuration = (value) => {
    setConsDuration(value);
  };

  const isValidTime = (timeStr) => {
    return dayjs(timeStr, "HH:mm", true).isValid();
  };

  return (
    <Layouts>
      <div className="m-6">
        {slotLoader && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div>
          <div className="font-bold mt-3  shadow-[0_0_10px_rgba(0,0,0,0.15)] rounded-md px-4 py-4  bg-white">
            <div>
              <Form
                ref={formRef}
                autoComplete="off"
                initialValues={{
                  useraccount: loggedUser.user.account_Id,
                  clinic: loggedUser.user.clinic_Id,
                  user: loggedUser.user.userId,
                  inpersonfee: loggedUser.user.inpersonFee,
                  videofee: loggedUser.user.videoFee,
                  homeVisitfee: loggedUser.user.homeVisitFee,
                  consultationtype: appointmentTypes,
                }}
                className="w-full grid md:grid-cols-4 grid-cols-1 md:justify-center md:gap-2 md:items-center"
              >
                <Form.Item name="fromdate">
                  <DatePicker
                    placeholder="From Date"
                    format="MM/DD/YYYY"
                    className="w-[202px] md:h-12 h-8 "
                    onChange={handleFromDate}
                    // disabledDate={(current) => current && current.valueOf() < Date.now()}
                    disabledDate={(current) =>
                      current && current.isBefore(moment().startOf("day"))
                    }
                  />
                </Form.Item>

                <Form.Item name="todate">
                  <DatePicker
                    placeholder="To Date"
                    format="MM/DD/YYYY"
                    className="w-[202px] md:h-12 h-8 "
                    onChange={handleToDate}
                    disabledDate={(current) =>
                      current && current.valueOf() < Date.now()
                    }
                  />
                </Form.Item>

                <Form.Item name="duration" className="md:w-4/5 w-full">
                  <Select
                    onChange={handleConsDuration}
                    className="w-[202px] md:h-12 h-8 "
                    placeholder="Duration"
                  >
                    {durationArr.map((duration) => (
                      <Select.Option value={duration}>
                        {duration} minutes
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                // name="fromtime"
                >
                  <TimePicker
                    format="h:mm A"
                    className="w-[202px] md:h-12 h-8 "
                    onChange={(value) => handleFromTime(value)}
                    onSelect={(value) => handleFromTime(value)}
                    value={
                      isValidTime(availableFromTime)
                        ? dayjs(availableFromTime, "HH:mm")
                        : null
                    }
                    minuteStep={10}
                    needConfirm={false}
                    showNow={false}
                    disabledTime={disabledTime}
                    placeholder="Start Time"
                  />
                </Form.Item>

                <Form.Item
                //  name="totime"
                >
                  <TimePicker
                    placeholder="End Time"
                    format="h:mm A"
                    className="w-[202px] md:h-12 h-8 "
                    onChange={(value) => handleToTime(value)}
                    onSelect={(value) => handleToTime(value)}
                    value={
                      isValidTime(availableToTime)
                        ? dayjs(availableToTime, "HH:mm")
                        : null
                    }
                    minuteStep={10}
                    needConfirm={false}
                    showNow={false}
                  />
                </Form.Item>

                <div />
                <div />
                <div />
                <Form.Item name="consultationtype" className="w-72">
                  <Checkbox.Group
                    onChange={handleConsType}
                    value={appointmentTypes}
                  >
                    <Checkbox value="inPerson">In person</Checkbox>
                    <Checkbox value="video">Video</Checkbox>
                    <Checkbox value="home">Home Visit</Checkbox>
                  </Checkbox.Group>
                </Form.Item>
                <div />
                <div />
                <div />
                {appointmentTypes.includes("inPerson") && (
                  <>
                    <Form.Item name="inpersonfee" className="w-full">
                      <Input
                        placeholder="In-Person Fee"
                        disabled
                        name="regnumber"
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault(); // Prevent non-numeric and non-control key input
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item name="inpersondiscount" className="w-full">
                      <Input
                        placeholder="In-Person Discount"
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        suffix={
                          <span className="md:text-lg text-base font-medium">
                            %
                          </span>
                        }
                      />
                    </Form.Item>
                  </>
                )}

                {appointmentTypes.includes("video") && (
                  <>
                    <Form.Item name="videofee" className="w-full">
                      <Input
                        placeholder="Video Fee"
                        disabled
                        name="regnumber"
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault(); // Prevent non-numeric and non-control key input
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item name="videodiscount" className="w-full">
                      <Input
                        placeholder="Video Discount"
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        suffix={
                          <span className="md:text-lg text-base font-medium">
                            %
                          </span>
                        }
                      />
                    </Form.Item>
                  </>
                )}

                {appointmentTypes.includes("home") && (
                  <>
                    <Form.Item name="homeVisitfee" className="w-full">
                      <Input
                        placeholder="Home Visit Fee"
                        disabled
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item name="homeVisitDiscount" className="w-full">
                      <Input
                        placeholder="Home Visit Discount"
                        className="md:w-4/5 w-full md:h-12 h-10 outline-none border-2 md:p-2 p-1 rounded-lg"
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];

                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        suffix={
                          <span className="md:text-lg text-base font-medium">
                            %
                          </span>
                        }
                      />
                    </Form.Item>
                  </>
                )}

                {appointmentTypes.length === 0 ? (
                  <>
                    <div></div>
                    <div></div>
                    <div></div>
                  </>
                ) : appointmentTypes.length === 1 &&
                  (appointmentTypes.includes("video") ||
                    appointmentTypes.includes("inPerson")) ? (
                  <>
                    {/* <div></div> */}
                    <div></div>
                  </>
                ) : appointmentTypes.length === 2 &&
                  (appointmentTypes.includes("video") ||
                    appointmentTypes.includes("inPerson")) ? (
                  <>
                    <div></div>
                    <div></div>
                  </>
                ) : (
                  ""
                )}
              </Form>
              <div className="my-3">
                <div className="my-2">
                  <div className="my-2">
                    <label className="md:text-lg text-base font-medium">
                      Days
                    </label>
                    <span className="text-red-500">*</span>
                  </div>

                  <Checkbox.Group
                    name="checked"
                    onChange={handleDays}
                    value={days}
                  >
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 md:gap-1 md:flex-nowrap w-full md:w-max">
                      <Checkbox value="all">Select all</Checkbox>
                      <Checkbox value="sunday">Sunday</Checkbox>
                      <Checkbox value="monday">Monday</Checkbox>
                      <Checkbox value="tuesday">Tuesday</Checkbox>
                      <Checkbox value="wednesday">Wednesday</Checkbox>
                      <Checkbox value="thursday">Thursday</Checkbox>
                      <Checkbox value="friday">Friday</Checkbox>
                      <Checkbox value="saturday">Saturday</Checkbox>
                    </div>
                  </Checkbox.Group>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-lg">
            <div className="flex md:flex-row flex-col md:items-center items-end justify-end gap-3 mt-10 mb-5">
              {/* <button
              disabled={isLoading}
              className="md:min-w-32 w-[6rem] md:w-1/5 md:p-3 p-1 bg-brand-White rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow disabled:cursor-not-allowed disabled:opacity-50"
              onClick={handleSlotViewClose}
            >
              Cancel
            </button> */}
              <button
                disabled={isLoading}
                className="md:min-w-32 w-[6rem] md:w-1/5 md:p-3 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handleSlotSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {savedUserSlots && savedUserSlots.length > 0 ? (
          <div className="font-bold mt-3 shadow-[0_0_10px_rgba(0,0,0,0.15)] rounded-md px-4 py-2 bg-white">
            {/* ── Only change: grid-cols-1 on mobile, grid-cols-2 on sm, grid-cols-5 on desktop ── */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-1">
              {savedUserSlots.map((slot) => (
                <div
                  key={slot.id}
                  className="border flex-wrap-reverse rounded-lg h-[250px] bg-[#F1FFF9] shadow-md my-2"
                >
                  <div className="p-3 h-[200px]">
                    <div className="grid grid-cols-2 items-start">
                      <p className="w-28 font-sans text-[#828282] text-xs font-normal">
                        From Date:
                      </p>
                      <p className="font-sans text-[#333333] text-xs font-normal">
                        {slot.fromDate}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 items-start">
                      <p className="w-28 font-sans text-[#828282] text-xs font-normal">
                        To Date:
                      </p>
                      <p className="font-sans text-[#333333] text-xs font-normal">
                        {slot.toDate}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 items-start">
                      <p className="w-24 font-sans text-[#828282] text-xs font-normal">
                        Start time:
                      </p>
                      <p className="font-sans text-[#333333] text-xs font-normal">
                        {slot.fromTime}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 items-start">
                      <p className="w-24 font-sans text-[#828282] text-xs font-normal">
                        End time:
                      </p>
                      <p className="font-sans text-[#333333] text-xs font-normal">
                        {slot.toTime}
                      </p>
                    </div>
                    <div className="grid grid-cols-2 items-start">
                      <p className="font-sans text-[#828282] text-xs font-normal">
                        Days:
                      </p>
                      <p className="font-sans text-[#333333] text-[11px] font-normal">
                        {[
                          slot.sunday === "Y" && "Sun",
                          slot.monday === "Y" && "Mon",
                          slot.tuesday === "Y" && "Tue",
                          slot.wednesday === "Y" && "Wed",
                          slot.thursday === "Y" && "Thu",
                          slot.friday === "Y" && "Fri",
                          slot.saturday === "Y" && "Sat",
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </p>
                    </div>

                    <div className="grid grid-cols-2 items-start">
                      <p className="w-28 font-sans font-normal text-[#828282] text-xs">
                        Slot Status :
                      </p>
                      <p className="grid-cols-4 font-sans text-[#333333] text-xs flex font-normal gap-2">
                        Active
                        <Switch
                          className="h-3"
                          defaultChecked
                          onChange={() => handleInactiveSlot(slot)}
                        />
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 border-t-2 pl-2 mt-2">
                    <p className="w-28 mt-1 font-sans text-[#828282] font-normal">
                      Created Date :
                    </p>
                    <p className="grid-cols-4 font-sans mt-1 text-[#333333] text-xs flex justify-start font-normal">
                      {dayjs(slot.createdDate).format("DD/MM/YYYY")}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>No slots Published Yet </div>
        )}
        {/* {savedUserSlots.length > 0 && (
        <div className="p-3 rounded-lg">
          <h1 className="font-bold text-xl text-brand-primaryColor">
            Saved Slots :{" "}
          </h1>
          <div className="h-[300px] grid grid-cols-3 gap-2 place-items-center overflow-y-auto">
            {savedUserSlots && savedUserSlots.length !== 0
              ? savedUserSlots.map((item) => (
                  <SlotCard
                    data={item}
                    slotLoader={slotLoader}
                    handleSelectedUserSlot={handleInactiveSlot}
                  />
                ))
              : ""}
          </div>
        </div>
      )} */}
      </div>
    </Layouts>
  );
}

export default Slot;
